// material ui icons
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import AssuredWorkloadRoundedIcon from '@mui/icons-material/AssuredWorkloadRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import CelebrationRoundedIcon from '@mui/icons-material/CelebrationRounded';
import CloudOffRoundedIcon from '@mui/icons-material/CloudOffRounded';
import CompareArrowsRoundedIcon from '@mui/icons-material/CompareArrowsRounded';
import DataSaverOnRoundedIcon from '@mui/icons-material/DataSaverOnRounded';
import DateRangeRoundedIcon from '@mui/icons-material/DateRangeRounded';
import DomainAddRoundedIcon from '@mui/icons-material/DomainAddRounded';
import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
import ElectricMeterRoundedIcon from '@mui/icons-material/ElectricMeterRounded';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import EventBusyRoundedIcon from '@mui/icons-material/EventBusyRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import FunctionsRoundedIcon from '@mui/icons-material/FunctionsRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import HourglassBottomRoundedIcon from '@mui/icons-material/HourglassBottomRounded';
import InsertInvitationRoundedIcon from '@mui/icons-material/InsertInvitationRounded';
import InsightsIcon from '@mui/icons-material/Insights';
import KeyOffRoundedIcon from '@mui/icons-material/KeyOffRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import LanRoundedIcon from '@mui/icons-material/LanRounded';
import LegendToggleRoundedIcon from '@mui/icons-material/LegendToggleRounded';
import LightRoundedIcon from '@mui/icons-material/LightRounded';
import MonitorRoundedIcon from '@mui/icons-material/MonitorRounded';
import MoveDownRoundedIcon from '@mui/icons-material/MoveDownRounded';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import RouterRoundedIcon from '@mui/icons-material/RouterRounded';
import SavingsRoundedIcon from '@mui/icons-material/SavingsRounded';
import SentimentSatisfiedRoundedIcon from '@mui/icons-material/SentimentSatisfiedRounded';
import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import SquareFootRoundedIcon from '@mui/icons-material/SquareFootRounded';
import StackedBarChartRoundedIcon from '@mui/icons-material/StackedBarChartRounded';
import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import ThermostatAutoIcon from '@mui/icons-material/ThermostatAuto';
import ThumbUpRoundedIcon from '@mui/icons-material/ThumbUpRounded';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';

// shared components
import { ESGIcon } from '@/components/ui/icon/ESGIcon';

export const QuestionsList = [
  {
    services: ['PVO'],
    title: 'PVO',
    icon: <ThermostatAutoIcon />,
    sections: [
      {
        title: 'Besparelsesoverblik',
        questions: [
          {
            title: 'Hvor ser jeg energibesparelsen for min bygning?',
            icon: <SavingsRoundedIcon />,
            answer: (
              <>
                Under <b>Besparelsesoverblik</b> kan du trykke på den enkelte
                bygning og se det samlede forbrug med og uden vores optimering
                og dermed den samlede kWh- og CO2e-besparelse. Her har du selv
                mulighed for at indtaste CO2e-koefficienten for bygningen
                således den nøjagtige CO2-ækvivalente besparelse vises.
                <br />
                <br />
                Derudover kan du se det aflæste forbrug for den enkelte dag samt
                hvilke 9 dage vi aktivt styrer varmen i bygningen og den 10.
                dag, hvor vi slukker for vores optimering og bygningen derfor
                kører sin normale drift.
              </>
            ),
          },
          {
            title: 'Hvorfor kan jeg ikke se besparelsen lige nu?',
            icon: <ErrorOutlineRoundedIcon />,
            answer: (
              <>
                Da besparelsen er baseret på forbruget med og uden vores
                optimering, kræver det tilstrækkeligt med dage med data fra
                bygningen, for at kunne se energibesparelsen. Der kan derfor i
                starten af optimeringsperioden eller varmesæsonen potentielt
                være for lidt data, til at kunne angive besparelsen. I takt med
                at der kommer flere aktive- og baseline-dage kommer der også
                mere sammenligningsdata, og besparelsen kan derfor angives.
              </>
            ),
          },
          {
            title: 'Hvor kommer energidataene fra?',
            icon: <BoltRoundedIcon />,
            answer: (
              <>
                Energidataene og kWh-forbruget kommer fra jeres egen
                afregningsmåler. Det er altså hovedmålerdata direkte fra måleren
                eller via en data-integration med jeres forsyningsselskab, som
                vi bruger.
              </>
            ),
          },
        ],
      },
      {
        title: 'Kalender',
        questions: [
          {
            title: 'Hvordan opretter jeg en begivenhed i kalenderfunktionen?',
            icon: <AddRoundedIcon />,
            answer: (
              <>
                I kalenderoverblikket markerer du dagen og tidsperioden for
                begivenheden. Herefter navngiver du begivenheden eks.{' '}
                <i>elevsamtaler</i> og indtaster det nøjagtige start- og
                sluttidspunktet for begivenheden samt at bygningen er i brug.
                <br />
                <br />
                Til slut markerer du de blandesløjfer som dækker de
                bygningsdele, hvor begivenheden bliver afholdt og trykker{' '}
                <b>opret begivenhed</b>. Herefter ser du begivenheden fremgå i
                kalenderoverblikket.
              </>
            ),
          },
          {
            title: 'Hvordan lægger jeg en ferie ind i kalenderfunktionen?',
            icon: <CelebrationRoundedIcon />,
            answer: (
              <>
                I kalenderoverblikket markerer du de dage ferien finder sted.
                Herefter navngiver du ferien og indtaster start og sluttidspunkt
                for ferien samt at bygningen ikke er i brug.
                <br />
                <br />
                Til sidst markerer du de blandesløjfer, der dækker de
                bygningsdele, der ikke er i brug under ferien og trykker{' '}
                <b>opret begivenhed</b>. Herefter ser du ferien fremgå i
                kalenderoverblikket.
              </>
            ),
          },
          {
            title: 'Hvor lang tid i forvejen skal jeg oprette en begivenhed?',
            icon: <WatchLaterOutlinedIcon />,
            answer: (
              <>
                Når du opretter en begivenhed i kalenderen, vil styringen blive
                justeret inden for få minutter, så opvarmningen passer til
                begivenheden. Hvis begivenheden finder sted på en dag, hvor
                bygningen normalt ikke er i brug, som f.eks. i ferier eller
                weekender, anbefaler vi, at du opretter begivenheden senest
                dagen før, således komforttemperaturen sikres i tidsrummet for
                begivenheden.
              </>
            ),
          },
          {
            title:
              'Kan jeg lægge en begivenhed ind for en blandesløjfe, der forsyner et enkelt område i bygningen?',
            icon: <InsertInvitationRoundedIcon />,
            answer: (
              <>
                Når du indtaster en begivenhed i kalenderfunktionen, kan du
                markere lige nøjagtigt den blandesløjfe, som forsyner det
                område, du gerne vil have varme på til begivenheden.
              </>
            ),
          },
          {
            title:
              'Navngivningen af de enkelte blandesløjfer giver ikke mening',
            icon: <DriveFileRenameOutlineRoundedIcon />,
            answer: (
              <>
                Vi har forsøgt at lave navngivningen af de enkelte blandesløjfer
                gennemskuelig. Skulle I have ønsker til at få ændret navnet, så
                det er nemmere at lave begivenheder, som kun gælder dele af
                bygningen, så ræk ud til vores support, så omdøber vi det
                sammen.
              </>
            ),
          },
          {
            title:
              'Hvordan ser jeg de begivenheder jeg har lagt ind for den kommende måned?',
            icon: <DateRangeRoundedIcon />,
            answer: (
              <>
                Når du er inde i kalenderoverblikket, kan du oppe i højre hjørne
                skifte kalenderens visning mellem en måned, en uge eller en dag.
              </>
            ),
          },
          {
            title: 'Hvordan sletter jeg en begivenhed?',
            icon: <EventBusyRoundedIcon />,
            answer: (
              <>
                Hvis du fortryder en begivenhed i kalenderen, kan du altid
                slette den igen ved at trykke på den konkrete begivenhed og
                trykke <b>fjern begivenhed</b>.
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    services: ['EnergyXplorer', 'PortfolioAnalysis'],
    title: 'EnergyXplorer',
    icon: <InsightsIcon />,
    manualLink:
      'https://remoni.sharepoint.com/:b:/g/IQAPSQqIbSLXT7pywwvZHs-vAYiG6Va7B5p-C01Ft0JXpfU?e=Ep19Bq',
    sections: [
      {
        title: 'Portfolio',
        manualLink:
          'https://remoni.sharepoint.com/:b:/g/IQABGf2H-g7OS7IG6GGk0rSlAWIznFXzsDV6RCZeoDNUfGw',
        subsections: [
          {
            title: 'Generelt',
            questions: [
              {
                title: 'Hvad er formålet med Portfolio?',
                icon: <SentimentSatisfiedRoundedIcon />,
                answer: (
                  <>
                    Samlet overblik over alle hovedmålere i porteføljen. Med
                    intuitive nøgletal og metrikker kan det hurtigt vurderes,
                    hvordan ejendommenes forbrug har ændret sig over tid,
                    hvordan forbruget er fordelt på døgnet - og om forbruget er
                    uhensigtsmæssigt. Markér de ejendomme, som du vil holde øje
                    med. Sortér efter størst forbrug udenfor brugstid, i tiden
                    17-21, om natten sammenlignet med dagen, i weekenden osv.
                  </>
                ),
              },
              {
                title: 'Hvordan fungerer Portfolio?',
                icon: <QuestionMarkRoundedIcon />,
                answer: (
                  <>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://remoni.sharepoint.com/Delte%20dokumenter/Forms/Show%20100%20docs.aspx?id=%2FDelte%20dokumenter%2FSalg%20og%20Marketing%2FMarketing%2FHjemmesiden%2FPublic%20Website%20Documents%2FPortef%C3%B8ljeanalyse%20introduktion%2Epdf&parent=%2FDelte%20dokumenter%2FSalg%20og%20Marketing%2FMarketing%2FHjemmesiden%2FPublic%20Website%20Documents&p=true&ct=1765888111536&or=Outlook%2DBody&cid=DD349F7B%2D3D75%2D4022%2DB8CC%2D17B4E0F68E53&ga=1"
                    >
                      Klik her{' '}
                    </a>
                    for en introduktion til Portfolio, der forklarer hvordan du
                    kan bruge det til at analysere dit energiforbrug på tværs af
                    flere bygninger.
                  </>
                ),
              },
              {
                title: 'Hvordan tilføjer jeg nye brugere til værktøjet?',
                icon: <PersonAddAltRoundedIcon />,
                answer: (
                  <>
                    Hvis du ønsker at give en bruger adgang til værktøjet, kan
                    du kontakte vores supportteam via e-mail på{' '}
                    <b>support@remoni.dk</b> eller telefon{' '}
                    <b>+45 30 64 16 27</b>.
                    <br />
                    <br />
                    Oplys venligst navn og e-mailadresse på den bruger, der skal
                    tilføjes, så sørger vi for at oprette adgangen.
                  </>
                ),
              },
              {
                title:
                  'Hvordan håndterer værktøjet ændringer i bygninger – fx ombygninger, ny ventilation eller ændrede åbningstider?',
                icon: <SquareFootRoundedIcon />,
                answer: (
                  <>
                    Portfolio-værktøjet opdaterer automatisk bygningernes
                    brugsmønstre hvert kvartal ved hjælp af AI, hvis brugeren
                    ikke selv har defineret mønstret.
                    <br />
                    <br />
                    Husk at justere brugsmønster eller kategori manuelt ved
                    større ændringer – som ombygninger, ny ventilation eller
                    markant ændrede driftstider – for at sikre præcise analyser.
                    <br />
                    <br />
                    Justeringer foretages ved at åbne den relevante matrikel og
                    klikke på rediger-ikonet øverst i hjørnet.
                    <br />
                    <br />
                    Bygningsdata hentes som udgangspunkt fra BBR. Hvis BBR ikke
                    er opdateret efter ændringerne, anbefales det at rette disse
                    oplysninger manuelt samme sted.
                    <br />
                    <br />
                    Når der tilføjes flere hovedmålere til en bygning, der er
                    registreret hos Energinet, bliver disse automatisk
                    inkluderet i Portfolio-værktøjet.
                  </>
                ),
              },
              {
                title:
                  'Kan jeg eksportere data automatisk til egne rapporter (Power BI, Excel flows, API osv.)?',
                icon: <FileDownloadRoundedIcon />,
                answer: (
                  <>
                    ReMoni udstiller et åbent API, hvortil du kan trække
                    måledata ind i egne systemer og rapporter. Du kan se guiden
                    til API’et under:{' '}
                    <b>
                      Products - Platform - Recalc - Data - “Hent data fra
                      API’et”
                    </b>
                    .
                    <br />
                    <br />
                    Derudover er der mulighed for at hente målerdata ned for
                    hele din portefølje eller blot en enkelt hovedmåler via
                    manuel eksport til Excel eller CSV-fil.
                  </>
                ),
              },
              {
                title:
                  'Hvad gør jeg, hvis en måler mangler eller ikke dukker op i værktøjet?',
                icon: <ErrorOutlineRoundedIcon />,
                answer: (
                  <>
                    Manglende målere skyldes ofte:
                    <ul>
                      <li>
                        Forsyningsselskabet har ikke åbnet for måleraflæsninger
                        til tredjepart
                      </li>
                      <li>Måleren er fejlregistreret i DataHub</li>
                      <li>
                        Måleren hører til en anden adresse, end du forventer
                      </li>
                      <li>Filtre i værktøjet skjuler måleren</li>
                    </ul>
                    Start med at fjerne alle filtre og søg på adressen.
                    <br />
                    <br />
                    Kontakt ReMoni Support, hvis data stadig mangler:{' '}
                    <b>support@remoni.dk</b> eller <b>+45 30 64 16 27</b>.
                  </>
                ),
              },
              {
                title: 'Hvor hurtigt opdateres data?',
                icon: <SyncRoundedIcon />,
                answer: (
                  <>
                    Eldata opdateres typisk dagligt via DataHub. Vær opmærksom
                    på, at DataHub-data generelt kan være forsinket 2–4 dage,
                    før de vises i systemet.
                    <br />
                    <br />
                    Varme og vand afhænger af det enkelte forsyningsselskabs
                    datafrekvens – ofte 1 gang i døgnet eller én gang om
                    måneden.
                  </>
                ),
              },
            ],
          },

          {
            title: 'Analyser',
            questions: [
              {
                title: 'Bygningsdata',
                icon: <HomeWorkRoundedIcon />,
                answer: (
                  <>
                    Forbruget i en ejendom hænger unægteligt sammen med
                    baggrundsinformationer om bygningen. Denne sammenhæng kan
                    ses under ’Bygninger’, hvor bygningsdata samles automatisk
                    ind fra blandt andet BBR, så forbrug pr. kvadratmeter kan
                    ses. Undersøg, om der er en sammenhæng mellem hvad
                    ejendommen anvendes til, dens varmekilde, energimærke og
                    forbruget.
                  </>
                ),
              },
              {
                title:
                  'Hvad gør jeg, hvis to bygninger med samme type har meget forskelligt forbrug?',
                icon: <CategoryRoundedIcon />,
                answer: (
                  <>
                    Store forskelle skyldes typisk:
                    <ul>
                      <li>Forkerte BBR-arealer</li>
                      <li>
                        Forskellig varmeforsyning eller tekniske installationer
                      </li>
                      <li>Ældre vs. nyere styring og bygningsautomatik</li>
                      <li>
                        Forskellig udnyttelsesgrad (antal brugere, driftstider,
                        belægning)
                      </li>
                    </ul>
                    Start med at validere bygningsdata og brugsmønstre. Brug
                    derefter varme- og døgnanalyser til at undersøge drift og
                    nattelast.
                  </>
                ),
              },
              {
                title: 'Døgnforbrugsanalyse',
                icon: <EventRoundedIcon />,
                answer: (
                  <>
                    For den enkelte hovedmåler kan gennemsnitsforbruget for et
                    døgn ses. Dette giver intuitivt en forståelse af forbruget
                    på ejendommen, og man kan hurtigt vurdere, om noget ser
                    uhensigtsmæssigt ud. Sammenlign hverdag med weekend, for
                    minimum- og maksimumværdier, eksportér data mv. Kan alt
                    forbruget forklares?
                  </>
                ),
              },
              {
                title: 'Varighedsanalyse',
                icon: <WatchLaterOutlinedIcon />,
                answer: (
                  <>
                    Varighedsanalyse er et oplagt værktøj til at forstå hvor
                    stor en del af tiden elforbruget er højt og hvad spidslast
                    og grundlasten er for den enkelte ejendom. Dette er en
                    simpel måde at få en dyb forståelse af forbruget på. Hvor
                    meget af spidslasten ligger indenfor brugstid? Hvor stor en
                    procentdel af forbruget udgøres af grundlasten?
                  </>
                ),
              },
              {
                title: 'Årssammenligning',
                icon: <CompareArrowsRoundedIcon />,
                answer: (
                  <>
                    Med årssammenligningen kan forbruget nemt sammenlignes med
                    forbruget sidste år. Se hvilke måneder, hvor forskellen er
                    størst. Dette simple overblik kan være med til at sætte
                    retning for ens yderligere undersøgelser.
                  </>
                ),
              },
              {
                title: 'Hovedmålerdata',
                icon: <ElectricMeterRoundedIcon />,
                answer: (
                  <>
                    Når hovedmålerdata visualiseres, forenkles overblik og
                    analyser. Se forbruget for dén periode, som du ønsker; fulde
                    år, enkelte måneder eller bare et par timer en konkret dag.
                    Hvad skyldes en stigning i forbrug? Hvordan er forbruget hen
                    over kalenderåret? Er der tydelige udfordringer eller bare
                    et for højt grundlastforbrug? Vælg perioden, eksportér data
                    eller brug data til jeres næste energispareprojekt.
                  </>
                ),
              },
              {
                title:
                  'Hvordan finder jeg de største besparelsespotentialer i en stor portefølje?',
                icon: <SavingsRoundedIcon />,
                answer: (
                  <>
                    Start med:
                    <ol>
                      <li>
                        Standard-fanen: kig efter højt forbrug udenfor brugstid
                      </li>
                      <li>
                        Brugsmønstre-fanen: tjek forskellen mellem
                        indeni/udenfor drift
                      </li>
                      <li>Døgnforbrug: identificér natlast</li>
                      <li>
                        Trendanalyse: tjek hvorvidt forbruget har været stigende
                        eller faldende inde og udenfor brugstid
                      </li>
                      <li>Temperaturanalyse: find dårlig afkøling</li>
                      <li>Bygninger-fanen: spot outliers i kWh/m²</li>
                    </ol>
                    Denne kombination peger ofte på de største potentialer.
                  </>
                ),
              },
              {
                title:
                  'Kan Portfolio analysen vise forbrug fordelt på afdelinger eller lejemål?',
                icon: <AccountTreeRoundedIcon />,
                answer: (
                  <>
                    Alle registrerede hovedmålere vises på en tilknyttet
                    adresse. Hvis intern fordeling eller submålinger er et
                    behov, og hovedmålerdata ikke er tilstrækkelig, anbefales
                    installation af ReMonis clamp-on sensorer og bimålere samt
                    brug af DeepDive for at gå i dybden med den enkelte matrikel
                    eller ejendom.
                  </>
                ),
              },
            ],
          },
        ],
      },
      {
        title: 'DeepDive',
        subsections: [
          {
            title: 'Generelt',
            questions: [
              {
                title: 'Hvad er formålet med DeepDive?',
                icon: <SentimentSatisfiedRoundedIcon />,
                answer: (
                  <>
                    DeepDive handler om at forstå ressourceforbruget i hver
                    enkelt bygning i dybden - fra din hovedmåler og ned til de
                    enkelte energiforbrugere. Dette giver dig en detaljeret
                    indsigt i dit forbrug, så du kan afdække muligheder for
                    initiativer, der kan spare energi og samtidig opfylde
                    lovmæssige rapporteringskrav ved hjælp af specifik,
                    dataunderstøttet dokumentation.
                  </>
                ),
              },
              {
                title: 'I hvilket datainterval kan jeg se værdierne?',
                icon: <WatchLaterOutlinedIcon />,
                answer: (
                  <>
                    I DeepDive vises dine målinger som timeværdier, så du får et
                    klart og overskueligt overblik over energiforbruget.
                    <br />
                    <br />
                    Selve målerne kan dog registrere data helt ned til
                    3-sekunders intervaller, hvilket gør det muligt at lave
                    meget detaljerede analyser af forbrugsmønstre, peaks og
                    uregelmæssigheder.
                    <br />
                    <br />
                    Hvis du ønsker at arbejde med de helt fintmaskede data eller
                    dykke dybere ned i avancerede analyser, er du velkommen til
                    at kontakte ReMoni på <b>+45 30 64 16 27</b> eller{' '}
                    <b>support@remoni.dk</b>, så hjælper vi dig videre.
                  </>
                ),
              },
              {
                title: 'Hvad gør jeg, hvis der mangler data i DeepDive?',
                icon: <ErrorOutlineRoundedIcon />,
                answer: (
                  <>
                    Manglende data i DeepDive skyldes typisk én af følgende
                    årsager:
                    <ul>
                      <li>Sensorkommunikationen er afbrudt</li>
                      <li>Gatewayen er offline</li>
                      <li>Sensoren er flyttet eller blevet løsnet</li>
                    </ul>
                    Tjek installationen i tavlen. Hvis du er i tvivl, er du
                    altid velkommen til at kontakte ReMonis support på{' '}
                    <b>support@remoni.dk</b> eller <b>+45 30 64 16 27</b>, så
                    hjælper vi dig videre.
                    <br />
                    <br />
                    Hvis det er hovedmålerdata fra DataHub, der mangler, så vær
                    opmærksom på, at DataHub-data generelt kan være forsinket
                    2–4 dage, før de vises i systemet.
                  </>
                ),
              },
              {
                title: 'Hvordan opretter og sletter jeg et DeepDive?',
                icon: <AddRoundedIcon />,
                answer: (
                  <>
                    Du administrerer dine DeepDives via tandhjulet øverst til
                    højre i vinduet, lige ved siden af periodevælgeren.
                    <br />
                    <br />
                    Her kan du nemt:
                    <ul>
                      <li>Tilføje et nyt DeepDive</li>
                      <li>Redigere et eksisterende DeepDive</li>
                      <li>Slette et DeepDive</li>
                    </ul>
                    Hvis du vil oprette et nyt DeepDive, klikker du på{' '}
                    <b>Tilføj DeepDive</b> ved tandhjulet. Herefter kan du
                    angive:
                    <ul>
                      <li>Navnet på dit DeepDive</li>
                      <li>Adressen</li>
                      <li>Om det vedrører el, vand eller varme</li>
                    </ul>
                    Når du har gemt ændringerne, opretter systemet dit DeepDive
                    og gør det klar til brug, så du kan bygge et neddelingstræ
                    under det.
                  </>
                ),
              },
            ],
          },

          {
            title: 'Neddeling',
            questions: [
              {
                title:
                  'Hvordan organiserer jeg bedst mine målepunkter i neddelings-træet?',
                icon: <LanRoundedIcon />,
                answer: (
                  <>
                    Et godt neddelingstræ følger den fysiske elinstallation i
                    bygningen:
                    <ul>
                      <li>
                        Start med hovedtavle - tavler - undertavler -
                        elforbrugende enheder
                      </li>
                      <li>
                        Gruppér efter funktion (fx ventilation, køl, belysning)
                      </li>
                      <li>
                        Navngiv konsekvent, så du kan søge og genkende let
                      </li>
                    </ul>
                    Det giver også bedre datakvalitet ved fremtidige analyser.
                  </>
                ),
              },
              {
                title:
                  'Hvorfor står der, at forbruget er 100 % ukendt for et specifikt område eller en tavle?',
                icon: <AssessmentRoundedIcon />,
                answer: (
                  <>
                    Når et område eller en tavle vises som 100 % ukendt, betyder
                    det, at der ikke er tilknyttet målepunkter til de
                    komponenter eller delområder, der hører under tavlen.
                    Systemet har dermed ingen data at fordele tavlens forbrug ud
                    fra, og derfor fremstår hele forbruget som ukendt i
                    neddelingsstrukturen.
                    <br />
                    <br />
                    Hvis der er forbrugere i tavlen, som du gerne vil have målt
                    og synliggjort i DeepDive, er du velkommen til at kontakte
                    ReMoni på <b>+45 30 64 16 27</b> eller{' '}
                    <b>support@remoni.dk</b>, så hjælper vi dig videre.
                  </>
                ),
              },
              {
                title: 'Hvordan flytter jeg en node?',
                icon: <MoveDownRoundedIcon />,
                answer: (
                  <>
                    For at flytte en node skal du blot holde musen hen over den
                    pågældende node. Her får du vist et ”flyt”-ikon, som du kan
                    klikke på.
                    <br />
                    <br />
                    Derefter vælger du den node, du ønsker at flytte den valgte
                    node under. Systemet opdaterer strukturen med det samme, og
                    efterfølgende opdateres data inden for 5-10 minutter.
                  </>
                ),
              },
            ],
          },

          {
            title: 'Analyser',
            questions: [
              {
                title: 'Forbrugsoverblik',
                icon: <MonitorRoundedIcon />,
                answer: (
                  <>
                    Elforbruget kan neddeles på tavleniveau og ned på enkelte
                    forbrugere. I forbrugsoverblikket fås et samlet billede af
                    hovedmålerforbrug og det neddelte forbrug – både for de
                    enkelte tavler og de enkelte forbrugere (fx Significant
                    Energy Users jf. ISO 50001).
                    <br />
                    Derudover fremgår åbningstiden og adressen for den enkelte
                    energigruppe som du selv har mulighed for at redigere under
                    tandhjulet.
                  </>
                ),
              },
              {
                title: 'Neddelingsanalyse',
                icon: <StackedBarChartRoundedIcon />,
                answer: (
                  <>
                    Med neddelingsanalysen kan du lave intuitive analyser på
                    elforbruget – så problemer, der før var skjult i
                    hovedmålerdata kan forstås og indsigten i driften kan
                    løftes. Se hvordan forbruget bliver brugt på underliggende
                    forbrugere og tavler og se hvordan forbruget er fordelt i
                    aktive og inaktive timer samt weekender og hverdage. Brug
                    værktøjet til at dykke i dybden med jeres forbrug.
                  </>
                ),
              },

              {
                title: 'Døgnforbrugsanalyse',
                icon: <EventRoundedIcon />,
                answer: (
                  <>
                    Døgnforbrugsanalysen viser dig, hvordan forbruget fordeler
                    sig over et døgn. På dén måde kan man intuitivt se, om
                    aktivitetsmønstre er som forventede, om driftsindstillinger
                    påvirker elforbruget korrekt og i øvrigt spotte
                    uhensigtsmæssigheder for øget forståelse. Sammenhold data
                    for weekender med hverdage og dyk i dybden med underliggende
                    målinger.
                  </>
                ),
              },
              {
                title: 'Sammenligningsanalyse',
                icon: <CompareArrowsRoundedIcon />,
                answer: (
                  <>
                    Analysér de enkelte målepunkter som tavler og enkelte
                    forbrugere - og sammenlign dem med hinanden. Dette giver
                    mulighed for at se hvordan forbruget bevæger sig, man kan
                    sammenligne målepunkter og se, hvordan fx ventilationsanlæg
                    drifter i forhold til hinanden, hvor stor en andel af et
                    forbrug fx indblæsningsmotoren udgør og meget mere.
                  </>
                ),
              },
              {
                title: 'Varighedsanalyse',
                icon: <WatchLaterOutlinedIcon />,
                answer: (
                  <>
                    Varighedsanalyse er et oplagt værktøj til at forstå hvor
                    stor en del af tiden elforbruget er højt. Dette kan anvendes
                    til for eksempel at sikre, at driften er indstillet korrekt,
                    at maskiner, motorer og lignende kører optimalt – og i
                    øvrigt til at give indsigt i, hvor stor en belastning en
                    given forbruger er samt hvorvidt dens spidslast fordeler sig
                    i de aktive/inaktive timer.
                  </>
                ),
              },
              {
                title: 'Belastningsanalyse',
                icon: <LegendToggleRoundedIcon />,
                answer: (
                  <>
                    Få indsigt i, hvordan elforbruget fordeler sig på det
                    enkelte målepunkt eller din hovedmåler. Analysen viser, hvor
                    stor en andel af forbruget der ligger i grundbelastning,
                    mellembelastning og spidsbelastning – og giver dermed et
                    klart billede af belastningsmønsteret i perioden og hvorvidt
                    trenden er op- eller nedadgående for belastningen.
                  </>
                ),
              },
            ],
          },

          {
            title: 'ESG',
            questions: [
              {
                title: 'ESG',
                icon: <ESGIcon />,
                answer: (
                  <>
                    I ESG-fanen findes CO2e-belastningen fra elforbruget.
                    CO2e-udledningen angives i både lokationsbaseret,
                    kommunebaseret og markedsbaseret udledning. Brug værdierne i
                    klimarapportering, ESG-rapporten eller for at optimere
                    elforbruget mod mindst mulig CO2e-belastning. Hvis der er
                    købt grønne certifikater, kan dette tilføjes og medregnes i
                    den markedsbaserede udledning ved at tilføje en andel af GO.
                    <br />
                    Hvis der er oprettet reduktionsinitiativer for den enkelte
                    energigruppe, vises både energibesparelse og CO₂e-besparelse
                    for hvert initiativ nederst i ESG-fanen.
                  </>
                ),
              },
              {
                title: 'Hvordan bruger jeg DeepDive til ESG-rapportering?',
                icon: <SummarizeRoundedIcon />,
                answer: (
                  <>
                    DeepDive giver dig et detaljeret indblik i elforbruget helt
                    ned på komponentniveau. Når du kombinerer disse data med
                    ESG-fanen, får du et samlet overblik over:
                    <ul>
                      <li>
                        CO₂-udledning både pr. hovedmåler og pr. enkelt
                        installation
                      </li>
                      <li>
                        Dokumenterede energibesparelser fra jeres gennemførte
                        tiltag
                      </li>
                      <li>
                        Fordelingen af energikilder baseret på markeds-,
                        kommune- eller lokationsmetode
                      </li>
                    </ul>
                    Denne kombination gør det nemt at anvende data direkte i
                    årsrapporter, grønne regnskaber og arbejde med ISO
                    50001-standarden.
                    <br />
                    <br />
                    Der er desuden mulighed for at eksportere de relevante data
                    til Excel, så de kan indgå i jeres egne
                    rapporteringsværktøjer.
                  </>
                ),
              },
              {
                title:
                  'Hvordan tilføjer jeg købte GO’er (grønne oprindelsescertifikater) til den markedsbaserede CO₂-udledning?',
                icon: <AddRoundedIcon />,
                answer: (
                  <>
                    I visningen for markedsbaseret CO₂-udledning kan du se, hvor
                    stor en andel af dit elforbrug der allerede er dækket af
                    GO’er. For at tilføje eller justere dine egne købte GO’er
                    skal du:
                    <ol>
                      <li>Gå til markedsbaseret CO₂-udledning i ESG-fanen</li>
                      <li>Kig til højre, hvor GO-procenten vises</li>
                      <li>Klik på tandhjulet (indstillinger)</li>
                      <li>
                        Indtast den ønskede procentandel af GO’er samt den
                        relevante gyldighedsperiode
                      </li>
                    </ol>
                    Herefter opdaterer systemet automatisk din markedsbaserede
                    CO₂-udledning ud fra de GO’er, du har angivet.
                  </>
                ),
              },
            ],
          },

          {
            title: 'Initiativer',
            questions: [
              {
                title: 'Hvad er formålet med initiativ-fanen?',
                icon: <SentimentSatisfiedRoundedIcon />,
                answer: (
                  <>
                    Initiativ-fanen bruges til at dokumentere og beregne
                    energibesparelser og CO₂e-reduktioner efter udførte tiltag
                    (f.eks. udskiftning af belysning eller ændring af
                    ventilationsstyring). Initiativerne gør det muligt at følge
                    effekten af forbedringer over tid – og give et dokumenteret
                    grundlag for ESG-rapportering og energistyring.
                  </>
                ),
              },
              {
                title: 'Hvilken metode anvendes til beregning af besparelser?',
                icon: <FunctionsRoundedIcon />,
                answer: (
                  <>
                    Initiativberegningerne i DeepDive er baseret på den
                    internationalt anerkendte standard IPMVP (International
                    Performance Measurement and Verification Protocol), som
                    sikrer valid og transparent dokumentation af
                    energibesparelser.
                    <br />
                    <br />
                    IPMVP anvendes bredt i både private og offentlige projekter
                    og giver rygdækning ift. revision, klimaregnskab og grøn
                    finansiering.
                  </>
                ),
              },
              {
                title: 'Hvordan vurderes effekten af et initiativ?',
                icon: <DataSaverOnRoundedIcon />,
                answer: (
                  <>
                    Vi anvender to metoder, afhængigt af datakvaliteten:
                    <br />
                    <br />
                    <b>
                      ReMoni&apos;s algoritme (AI-baseret prædiktionsmodel):
                    </b>
                    <br />
                    <ul>
                      <li>
                        Hvis modellen med høj nøjagtighed kan forudsige det
                        faktiske forbrug i baselineperioden, bruges den til at
                        forudsige det forventede forbrug i
                        sammenligningsperioden.
                      </li>
                      <li>
                        Det kræver typisk mindst 2 uger sammenhængende data i
                        baselineperioden for at opnå et godt grundlag for
                        prædiktion.
                      </li>
                      <li>
                        Prædiktionen giver en stærk, datadrevet vurdering af den
                        opnåede besparelse.
                      </li>
                    </ul>
                    <br />
                    <b>Gennemsnitsberegning (fallback):</b>
                    <br />
                    <ul>
                      <li>
                        Hvis modellen ikke kan prædikere tilstrækkeligt præcist,
                        anvendes et simpelt gennemsnit af baseline- og
                        sammenligningsperiodens forbrug til at vurdere
                        besparelsen.
                      </li>
                      <li>
                        Dette er tydeligt markeret i brugerfladen som
                        &quot;Gennemsnitligt forbrug&quot;.
                      </li>
                    </ul>
                  </>
                ),
              },
              {
                title: 'Hvornår er et initiativ "Klar til rapportering"?',
                icon: <ThumbUpRoundedIcon />,
                answer: (
                  <>
                    Følgende kriterier skal være opfyldt:
                    <br />
                    <ul>
                      <li>
                        Både baseline- og sammenligningsperiode er defineret.
                      </li>
                      <li>
                        CO₂e-deklarationsdata er tilgængelige for hele
                        sammenligningsperioden.
                      </li>
                      <li>
                        Systemet har foretaget den endelige beregning af kWh- og
                        CO₂e-besparelser.
                      </li>
                    </ul>
                    <br />
                    Når initiativet er i denne status, vises det også automatisk
                    i ESG-fanen til brug i klimaregnskaber og dokumentation.
                  </>
                ),
              },
              {
                title:
                  'Hvorfor kan mit initiativ stå "Under beregning" i flere dage?',
                icon: <HourglassBottomRoundedIcon />,
                answer: (
                  <>
                    Et initiativ kan ikke færdigberegnes før CO₂e-deklarationer
                    er tilgængelige for hele sammenligningsperioden. Da disse
                    data kan være 2-5 dage forsinket fra Energistyrelsen, må man
                    i tilfælde vente nogle dage efter slutdatoen, før
                    initiativet flyttes til &quot;Klar til rapportering&quot;.
                  </>
                ),
              },
              {
                title: 'Hvad betyder "Fremskrevet besparelse til dato"?',
                icon: <SavingsRoundedIcon />,
                answer: (
                  <>
                    Når et initiativ er færdigberegnet, estimeres en
                    &quot;fremskrevet besparelse til dato&quot;, som viser hvad
                    den målte besparelse ville være, hvis effekten var fortsat
                    frem til dags dato.
                    <br />
                    <br />
                    Det er et estimat – og kan variere, hvis bygningens drift,
                    brug eller installationer ændres efter initiativets
                    implementering.
                  </>
                ),
              },
            ],
          },
        ],
      },
    ],
  },

  {
    services: ['DatahubIntegration'],
    title: 'DataHub-integration',
    sections: [
      {
        title: 'Generelt',
        questions: [
          {
            title: 'Hvad er formålet med DataHub-integrationen?',
            icon: <SentimentSatisfiedRoundedIcon />,
            answer: (
              <>
                Formålet med DataHub-integrationen er at give ReMoni adgang til
                virksomhedens hovedmålerdata (el) fra eloverblik.dk via en
                tredjepartsfuldmagt. Når integrationen er gennemført, bliver
                data automatisk hentet og gjort tilgængelige i ReMoni-portalen
                til videre analyse og visualisering.
              </>
            ),
          },
          {
            title: 'Hvem kontakter jeg, hvis noget går galt?',
            icon: <SupportAgentRoundedIcon />,
            answer: (
              <>
                Hvis du oplever fejl, manglende data eller usædvanlig ventetid
                (over 24 timer), kan du kontakte ReMonis kundeservice for hjælp.
              </>
            ),
          },
        ],
      },
      {
        title: 'Oprettelse',
        questions: [
          {
            title: 'Hvordan opretter jeg en fuldmagt?',
            icon: <KeyRoundedIcon />,
            answer: (
              <>
                Klik på knappen <b>Opret fuldmagt</b> i brugerfladen. Du bliver
                herefter guidet til DataHubs fuldmagtsformular, hvor du skal
                give ReMoni A/S adgang som datamodtager. Fuldmagten skal
                udfyldes af en person med MitID-rettigheder til den virksomhed,
                som målepunkterne tilhører.
              </>
            ),
          },
          {
            title:
              'Hvad gør jeg, hvis jeg ikke selv har adgang til at oprette fuldmagten?',
            icon: <KeyOffRoundedIcon />,
            answer: (
              <>
                Du kan kopiere linket til fuldmagtsformularen og sende det
                videre til den person i din organisation, der har de nødvendige
                rettigheder (MitID med adgang til virksomhedens hovedmålerdata).
              </>
            ),
          },
          {
            title: 'Kan jeg tilføje flere virksomheder eller kunder?',
            icon: <DomainAddRoundedIcon />,
            answer: (
              <>
                Ja, du kan oprette flere fuldmagter - én for hver virksomhed
                eller kunde, du ønsker at hente målerdata fra. Du skal blot
                gentage processen og indtaste det relevante CVR-nummer for hver
                virksomhed.
              </>
            ),
          },
          {
            title: 'Hvordan henter jeg data efter oprettelse af fuldmagten?',
            icon: <ShowChartRoundedIcon />,
            answer: (
              <>
                Efter at fuldmagten er godkendt, skal du indtaste virksomhedens
                <b>CVR-nummer</b> i feltet under <b>Trin 2: Hent data</b>.
                ReMonis system begynder herefter at hente data fra DataHub.
              </>
            ),
          },
          {
            title:
              'Hvor lang tid går der, før mine data er synlige i portalen? ',
            icon: <WatchLaterOutlinedIcon />,
            answer: (
              <>
                Normalt tager det cirka <b>10 minutter</b>, men ved store
                porteføljer kan det tage op til et par timer. Hvis du også har
                <b>porteføljeoverblik</b> aktiveret, kan det tage yderligere
                <b>15 minutter til 1 time</b>, før beregningerne er klar.
              </>
            ),
          },
          {
            title: 'Hvad sker der, hvis DataHub er offline?',
            icon: <CloudOffRoundedIcon />,
            answer: (
              <>
                DataHub kan i sjældne tilfælde være midlertidigt nede. Ofte er
                det kun i få sekunder, men det kan i enkelte tilfælde vare
                længere. Hvis du oplever problemer, kan du prøve at gentage
                processen med at indtaste CVR-nummeret efter et kort stykke tid.
                Integrationer gennemføres typisk inden for <b>24 timer</b>, selv
                ved nedetid. Kontakt ReMoni support, hvis du oplever
                længerevarende problemer.
              </>
            ),
          },
          {
            title: 'Hvordan ved jeg, at integrationen er gennemført?',
            icon: <AssuredWorkloadRoundedIcon />,
            answer: (
              <>
                Når integrationen er aktiv, vises virksomheden og CVR-nummeret
                under inputfeltet med et grønt flueben og dato for datoperioden.
                Det indikerer, at dataene er under indhentning eller allerede
                tilgængelige.
              </>
            ),
          },
          {
            title: 'Skal jeg gøre noget for at holde integrationen i gang? ',
            icon: <EngineeringRoundedIcon />,
            answer: (
              <>
                Nej, når fuldmagten er givet, og CVR-nummeret er indtastet,
                fortsætter ReMonis system med at hente data løbende - så længe
                DataHub er online og fuldmagten er aktiv.
              </>
            ),
          },
        ],
      },
    ],
  },
  {
    services: ['Devices'],
    title: 'Devices',
    icon: <EngineeringRoundedIcon />,
    questions: [
      {
        title: 'Generelt',
        icon: <SentimentSatisfiedRoundedIcon />,
        answer: (
          <>
            ReMonis devices omfatter både gateways og sensorer, som er designet
            til at indsamle og transmittere data om energiforbrug og indeklima.
            Disse enheder er afgørende for at få detaljeret indsigt i bygningers
            drift og for at kunne optimere energiforbruget effektivt.
          </>
        ),
      },
      {
        title: 'Gateways',
        icon: <RouterRoundedIcon />,
        tour: true,
        tourKey: 'gateways',
        tourPath: '/$accountId/gateways',
        tourLabel: 'Prøv guiden',
        answer: (
          <>
            Gateways er enheder, der videresender data fra sensorerne til ReMoni
            platformen. Sensorer, som ikke selv kan oprette forbindelse til
            internettet, skal være inden for rækkevidde af en gateway, for at
            data kan blive indsamlet. Gateways behøver ikke at være registreret
            for at virke; de videresender alle sensordata, de modtager, så længe
            de har en aktiv internetforbindelse. For at ændre indstillingerne
            for en gateway skal den dog registreres.
          </>
        ),
      },
      {
        title: 'Sensorer',
        icon: <SpeedRoundedIcon />,
        tour: true,
        tourKey: 'sensors-overview',
        tourPath: '/$accountId/sensors',
        tourLabel: 'Prøv guiden',
        answer: (
          <>
            ReMonis sensorer er også kaldet clamp-on sensorer, da de monteres
            ved at klemme dem fast på en ledning eller rør. Disse sensorer
            findes i forskellige varianter, som måler elforbrug, vandforbrug,
            varme, temperatur, luftfugtighed og CO₂. Sensorerne kommunikerer
            trådløst med gateways og kan opdateres Over-the-Air for at sikre
            optimal ydeevne og nøjagtighed. De er designet til nem installation
            uden behov for at afbryde Strømmen eller åbne tavler, hvilket gør
            dem ideelle til både nye og eksisterende installationer.
          </>
        ),
      },
      {
        title: 'Units',
        icon: <LightRoundedIcon />,
        tour: true,
        tourKey: 'units-overview',
        tourPath: '/$accountId/units',
        tourLabel: 'Prøv guiden',
        answer: (
          <>
            Units er fysiske enheder, som har sensorer tilknyttet. Det kan være
            maskiner, du vil overvåge, f.eks. for at se hvor meget el de
            forbruger, eller hvor effektivt de arbejder. For at kunne overvåge
            en maskines ressourceforbrug eller performance skal den registreres
            her sammen med de sensorer, der er tilknyttet den.
          </>
        ),
      },
    ],
  },
  {
    services: ['Analytics'],
    title: 'Analytics',
    icon: <InsightsIcon />,
    questions: [
      {
        title: 'Data visning',
        icon: <ShowChartRoundedIcon />,
        tour: true,
        tourKey: 'view-data',
        tourPath: '/$accountId/view-data',
        tourLabel: 'Prøv guiden',
        answer: (
          <>
            Data visning er stedet, hvor du kan se og analysere målt data fra
            dine units. Her vælger du units, periode, aggregering og kan følge
            de nyeste målinger med Live-visning.
          </>
        ),
      },
      {
        title: 'Eksportér Data',
        icon: <FileDownloadRoundedIcon />,
        tour: true,
        tourKey: 'export-data',
        tourPath: '/$accountId/export-data',
        tourLabel: 'Prøv guiden',
        answer: (
          <>
            Eksportér Data er stedet, hvor du kan hente målt data ud fra ReCalc.
            Her vælger du units, periode, aggregering, kolonner og format, inden
            du eksporterer filen.
          </>
        ),
      },
    ],
  },
];
